import type { NewApptState } from '../types';

const selectSlotId = (state: NewApptState) => state.newAppt.slot.id;

export { selectSlotId };
